import { useMemo } from "react";
import {
  ContractorLoadingState,
  ContractorLoadingReason,
  MutationsObject,
  QueriesObject,
} from "../context/ContractorContext";

export const useContractorLoading = (
  queries: QueriesObject,
  mutations: MutationsObject,
): ContractorLoadingState => {
  return useMemo((): ContractorLoadingState => {
    const { isFetching, isLoading } = queries.contractorQuery;

    const loadingStates: {
      condition: boolean;
      reason: ContractorLoadingReason;
    }[] = [
      { condition: isFetching || isLoading, reason: "fetching_contractor" },
      {
        condition: mutations.activateContractorMutation.isPending,
        reason: "activating_contractor",
      },
      {
        condition: mutations.deactivateContractorMutation.isPending,
        reason: "deactivating_contractor",
      },
      {
        condition: mutations.updateContractorMutation.isPending,
        reason: "updating_contractor",
      },
      {
        condition: mutations.deleteContractorMutation.isPending,
        reason: "deleting_contractor",
      },
    ];

    const activeState = loadingStates.find((state) => state.condition);
    return activeState
      ? { isLoading: true, reason: activeState.reason }
      : { isLoading: false };
  }, [
    queries.contractorQuery,
    mutations.activateContractorMutation.isPending,
    mutations.deactivateContractorMutation.isPending,
    mutations.updateContractorMutation.isPending,
    mutations.deleteContractorMutation.isPending,
  ]);
};
